import sharedSettings from 'shared/src/settings'

const units = sharedSettings.units

export default units